import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页", icon: "ri-home-5-line" },
  { to: "/category", label: "漫画分类", icon: "ri-apps-2-line" },
  { to: "/search", label: "搜索", icon: "ri-search-line" },
  { to: "/about", label: "关于我们", icon: "ri-information-line" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) {
      navigate("/search");
      return;
    }
    navigate(`/search?q=${encodeURIComponent(value)}`);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center gap-4 md:gap-8">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl">
              <i className="ri-book-open-line"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-foreground-950 text-base md:text-lg whitespace-nowrap">
                韩漫大全
              </span>
              <span className="text-[10px] md:text-xs text-foreground-500 whitespace-nowrap">
                无删减免费阅读
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const active =
                link.to === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(link.to);
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-3 lg:px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                    active
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          <form
            onSubmit={handleSearch}
            className="hidden lg:flex items-center flex-1 max-w-sm ml-auto"
          >
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
              <input
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索漫画名称或标签…"
                className="w-full h-10 pl-9 pr-3 rounded-md border border-background-300 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-accent-400 focus:ring-2 focus:ring-accent-200 transition"
              />
            </div>
          </form>

          <Link
            to="/search"
            className="lg:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-200 text-xl"
            aria-label="搜索漫画"
          >
            <i className="ri-search-line"></i>
          </Link>

          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-200 text-xl cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 animate-fade-in">
          <form
            onSubmit={handleSearch}
            className="flex items-center gap-2 mb-4"
          >
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索漫画名称或标签…"
                inputMode="search"
                className="w-full h-11 pl-9 pr-3 rounded-md border border-background-300 bg-background-100 text-sm outline-none focus:border-accent-400 focus:ring-2 focus:ring-accent-200"
              />
            </div>
            <button
              type="submit"
              className="h-11 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="flex items-center gap-3 px-3 py-3 rounded-md text-sm font-medium text-foreground-800 hover:bg-background-200"
              >
                <i className={`${link.icon} text-lg text-foreground-500`}></i>
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}